import { render, staticRenderFns } from "./contractType.vue?vue&type=template&id=553a150e&scoped=true"
import script from "./contractType.vue?vue&type=script&lang=js"
export * from "./contractType.vue?vue&type=script&lang=js"
import style0 from "./contractType.vue?vue&type=style&index=0&id=553a150e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a150e",
  null
  
)

export default component.exports